import { render, staticRenderFns } from "./ai-qa-config-select.vue?vue&type=template&id=4210f77c&scoped=true"
import script from "./ai-qa-config-select.vue?vue&type=script&lang=ts"
export * from "./ai-qa-config-select.vue?vue&type=script&lang=ts"
import style0 from "./ai-qa-config-select.vue?vue&type=style&index=0&id=4210f77c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4210f77c",
  null
  
)

export default component.exports